import {get,post} from '../utils/request';
// 获取学校账号列表
export const getSchoolMemberList = params => get('/member/getSchoolMemberList',params);
// 一键生成学校账号密码
export const makeSchoolAccount = params => post('/member/makeSchoolAccount',params);
// 修改学校账号
export const updateSchool = params =>post('/member/updateSchool',params);
// 获取协会账户
export const getSocietyList = params => get('/member/getSocietyList',params);
// 修改协会账户
export const updateSociety = params => post('/member/updateSociety',params);
// 删除学校账号包括其他关联数据
export const deleteSchools = params => post('/member/deleteSchool',params);